"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineQueryResults = void 0;
function combineQueryResults(queryResults) {
    if (queryResults.some(function (_a) {
        var status = _a.status;
        return status === 'no-data';
    })) {
        return {
            status: 'no-data',
            isFetching: queryResults
                .filter(function (_a) {
                var status = _a.status;
                return status === 'no-data';
            })
                .every(function (_a) {
                var isFetching = _a.isFetching;
                return isFetching;
            }),
        };
    }
    var refetch = function () {
        // @ts-ignore refetch must exist, because status must not be 'no-data'
        queryResults.forEach(function (_a) {
            var refetch = _a.refetch;
            refetch();
        });
    };
    if (queryResults.some(function (_a) {
        var status = _a.status;
        return status === 'error';
    })) {
        return {
            status: 'error',
            isFetching: queryResults
                .filter(function (_a) {
                var status = _a.status;
                return status === 'error';
            })
                .every(function (_a) {
                var isFetching = _a.isFetching;
                return isFetching;
            }),
            error: queryResults.map(function (qr) {
                return qr.status === 'error' ? qr.error : null;
            }),
            refetch: refetch,
        };
    }
    // No need to check, they must all be in the 'data' state
    return {
        status: 'data',
        // This isFetching is different from the others, because it's possible to have all data in a success state,
        // have 1 queryResult refetching and then have the combined state jump to an error state (data-no-fetching -> error-no-fetching).
        // Rather it should go from data-no-fetching -> data-fetching -> error-no-fetching.
        isFetching: queryResults.some(function (_a) {
            var isFetching = _a.isFetching;
            return isFetching;
        }),
        // @ts-ignore Data must exist
        data: queryResults.map(function (_a) {
            var data = _a.data;
            return data;
        }),
        refetch: refetch,
    };
}
exports.combineQueryResults = combineQueryResults;
